import { render, staticRenderFns } from "./vendedor.vue?vue&type=template&id=607d15f2&scoped=true&"
import script from "./vendedor.vue?vue&type=script&lang=js&"
export * from "./vendedor.vue?vue&type=script&lang=js&"
import style0 from "./vendedor.vue?vue&type=style&index=0&id=607d15f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607d15f2",
  null
  
)

export default component.exports